var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSequelize(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "file_type_sequelize") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M24.612,10.929V21.016l-8.571,5.071-.077.07v3.77l.077.073,12.071-6.972V8.972L28,8.945l-3.4,1.9.017.082",
    style: {
      fill: "#2f406a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.443,21.1l8.6,4.988V30L3.888,23V9l.125-.019,3.393,1.973.037.113V21.1",
    style: {
      fill: "#2379bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.443,11.067,3.888,9,16.014,2l12.1,6.972-3.5,1.957-8.6-4.906L7.443,11.067",
    style: {
      fill: "#03afef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.894,19.945l-.093-.1V16.062l.093-.048.023-.093,3.247-1.894.1.022v3.9l-3.369,1.993",
    style: {
      fill: "#2f406a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.469,18.073V14.021l.094,0,3.3,1.922.028.076v3.931l-3.425-1.872",
    style: {
      fill: "#2379bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.838,12.027l-3.369,1.993,3.425,1.993,3.369-1.965-3.425-2.021",
    style: {
      fill: "#03afef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7,22.415l-.093-.1V18.533l.093-.048.023-.093L14.971,16.5l.1.022v3.9L11.7,22.415",
    style: {
      fill: "#2f406a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.276,20.544V16.491l.094,0,3.3,1.922.028.076v3.931L8.276,20.544",
    style: {
      fill: "#2379bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.645,14.5,8.276,16.491,11.7,18.485,15.07,16.52,11.645,14.5",
    style: {
      fill: "#03afef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.386,22.509l-.093-.1V18.626l.093-.048.023-.093,3.247-1.894.1.022v3.9l-3.369,1.993",
    style: {
      fill: "#2f406a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.961,20.637V16.585l.094,0,3.3,1.922.028.076v3.931l-3.425-1.872",
    style: {
      fill: "#2379bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.33,14.592l-3.369,1.993,3.425,1.993,3.369-1.965L20.33,14.592",
    style: {
      fill: "#03afef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.193,24.98l-.093-.1V21.1l.093-.048.023-.093,3.247-1.894.1.022v3.9L16.193,24.98",
    style: {
      fill: "#2f406a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.768,23.108V19.056l.094,0,3.3,1.922.028.076V24.98l-3.425-1.872",
    style: {
      fill: "#2379bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.137,17.062l-3.369,1.993,3.425,1.993,3.369-1.965-3.425-2.022",
    style: {
      fill: "#03afef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.894,14.573l-.093-.1V10.69l.093-.048.023-.093,3.247-1.894.1.022v3.9l-3.369,1.993",
    style: {
      fill: "#2f406a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.469,12.7V8.649l.094,0,3.3,1.922.028.076v3.931L12.469,12.7",
    style: {
      fill: "#2379bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.838,6.656,12.469,8.649l3.425,1.993,3.369-1.965L15.838,6.656",
    style: {
      fill: "#03afef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7,17.044l-.093-.1V13.161l.093-.048.023-.093,3.247-1.894.1.022v3.9L11.7,17.044",
    style: {
      fill: "#2f406a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.276,15.172V11.12l.094,0,3.3,1.922.028.076v3.931L8.276,15.172",
    style: {
      fill: "#2379bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.645,9.126,8.276,11.12,11.7,13.113l3.369-1.965L11.645,9.126",
    style: {
      fill: "#03afef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.386,17.137l-.093-.1V13.255l.093-.048.023-.093,3.247-1.894.1.022v3.9l-3.369,1.993",
    style: {
      fill: "#2f406a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.961,15.266V11.213l.094,0,3.3,1.922.028.076v3.931l-3.425-1.872",
    style: {
      fill: "#2379bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.33,9.22l-3.369,1.993,3.425,1.993,3.369-1.965L20.33,9.22",
    style: {
      fill: "#03afef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.193,19.608l-.093-.1V15.725l.093-.048.023-.093,3.247-1.894.1.022v3.9l-3.369,1.993",
    style: {
      fill: "#2f406a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.768,17.736V13.684l.094,0,3.3,1.922.028.076v3.931l-3.425-1.872",
    style: {
      fill: "#2379bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.137,11.691l-3.369,1.993,3.425,1.993,3.369-1.965-3.425-2.022",
    style: {
      fill: "#03afef"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSequelize);
export default __webpack_public_path__ + "static/media/sequelize.e943e5dee3c61f0da89b2d680bb6292c.svg";
export { ForwardRef as ReactComponent };